<div class="matrix-input">
  <div class="control mb-3">
    <label><span [innerHTML]="label"></span><span class="required-indicator has-text-danger" *ngIf="required">*required</span></label>
  </div>

  <div class="table-container">
    <table class="table is-bordered is-striped">
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let col of config.columns" class="has-text-centered">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of config.rows">
          <tr>
            <td class="row-label">{{ row.label }}</td>
            <td *ngFor="let col of config.columns" class="has-text-centered">
              <input
                type="radio"
                [name]="rowName(row.key)"
                [checked]="isSelected(row.key, col.key)"
                (change)="onSelect(row.key, col.key)"
              />
            </td>
          </tr>
          <tr *ngIf="row.hasSpecify && hasSelection(row.key)" class="specify-row">
            <td [attr.colspan]="config.columns.length + 1">
              <div class="specify-input ml-4">
                <input
                  type="text"
                  class="input"
                  [value]="specifyText[row.key] || ''"
                  (input)="onSpecifyTextChange(row.key, $event)"
                  placeholder="Please specify..."
                />
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
